import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import RotationMeter from './RotationKpiMeter';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiModels from '../../../models/kpiModels';
import * as keyboardConstants from '../../../constants/keyboardConstants';

import {COMPONENT_TOOLTIP_OBJECT, COMPONENT_KPI_DASHBOARD_OBJECT} from  '../../../constants/componentConstants';
import {PERFORMANCE_CONFIG} from '../../../models/dialogModels';

import * as kpiConstants from '../../../constants/kpiConstants';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';

class KpiButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            staticKpiData: this.props.kpis,
            staticPrimaryKpi: kpiHelper.getPrimaryKpi(this.props.kpis),
            userBite: this.props.userBite,
            primaryKpi: this.props.primaryKpi,
            ariaHasPopup: true,
            lang: this.props.lang,
            label: appHelper.getLocaleString("performance_btn_label"),
        };

        this.setBtnClass = this.setBtnClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onClickFunc = this.onClickFunc.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(appHelper.isDefined(this.state.primaryKpi) && appHelper.isDefined(nextProps.primaryKpi) && this.state.primaryKpi.current !== nextProps.primaryKpi.current){
            this.setState({
                userBite: Object.assign({},nextProps.userBite),
                primaryKpi: Object.assign({},nextProps.primaryKpi)
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("performance_btn_label"),
            });
        }
    }

    setBtnClass(){
        return this.props.disabled ? "disabled" : "";
    }

    onClickFunc(){
        this.props.onClickFunc("performanceBtn");
    }


    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.onClickFunc();
        }
    }


    render() {
        let Component = COMPONENT_TOOLTIP_OBJECT;
        return (
            appHelper.isDefined(this.state.staticPrimaryKpi)
            ?
                <div className={`kpi-btn ${this.setBtnClass()}`} onClick={this.onClickFunc} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={!this.props.disabled ? "0" : "-1"} id="performanceBtn" aria-controls="performance" title={this.state.label} aria-haspopup={this.state.ariaHasPopup} aria-disabled={this.props.disabled}>
                    <RotationMeter bite_id={this.state.userBite.bite_id}  kpiDefaults={this.state.staticPrimaryKpi} meterParams={kpiModels.HEADER_KPI_ROTATION_METER_PARAMS} displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                </div>
            : <div className={`header-btn performance-btn`} onClick={this.onClickFunc} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={!this.props.disabled ? "0" : "-1"} id="performanceBtn" aria-controls="performance" title={this.state.label} aria-haspopup={this.state.ariaHasPopup} aria-disabled={this.props.disabled}>
                    <div className={`icon icons8-speed-2`}/>
                    <div className="btn-label">{this.state.label}</div>
                </div>

        );
    }
}


KpiButton.propTypes = {
    onClickFunc: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    bite_id: PropTypes.number.isRequired,
    kpis: PropTypes.array.isRequired,
    userBite: PropTypes.object.isRequired,
    primaryKpi: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

KpiButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let userBite = appHelper.getArrayObjectByKey(state.userData.bites,"bite_id",ownProps.bite_id);
    let lang = state.userData.lang;
    return {
        userBite: userBite,
        primaryKpi: kpiHelper.getPrimaryKpi(userBite.kpis),
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions, dialogPopupActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KpiButton);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiButton.js
 **/